export default __webpack_public_path__ + "static/media/header-logo.ceeb58b0.png";